export default "__VITE_ASSET__DstVW2TL__"